import { useContext } from "react";
import { CustomTimePiker } from "../../../../../../../../components";
import "./index.scss";
import Context from "../../../../../../../../context";
import utils from "../../../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../../../values/constants";
import { useTranslation } from "react-i18next";

const TimeFilter = () => {
  const { setRequestApproveParentTransaction, approvedParentTransaction } =
    useContext(Context.ApproveParentTransactionScreen);
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  return (
    <div className="time-filter-container">
      <label className="time-filter-item">
        از تاریخ
        <CustomTimePiker placeholder="تاریخ شروع" />
      </label>
      <label className="time-filter-item">
        تا تاریخ
        <CustomTimePiker placeholder="تاریخ پایان" />
      </label>
    </div>
  );
};

export default TimeFilter;
